module.exports = __webpack_public_path__ + "img/c2cBg.51df9372.png";